module.exports = __webpack_public_path__ + "static/media/zigloi1.b232f2c1.jpg";